require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-rise-against-procrastination.json") })
        }
      }, "path---blog-rise-against-procrastination");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-rise-against-procrastination!./.cache/json/blog-rise-against-procrastination.json
// module id = 274
// module chunks = 231608221292675